import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: string[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const RolesMenuSlice = createSlice({
  name: "getRolesMenu",
  initialState,
  reducers: {
    getRolesMenuStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getRolesMenuSuccess: (state, action: PayloadAction<string[]>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getRolesMenuFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetRolesMenu: () => {
      return { ...initialState };
    },
  },
});

export const {
  getRolesMenuStart,
  getRolesMenuSuccess,
  getRolesMenuFailed,
  resetRolesMenu,
} = RolesMenuSlice.actions;

export default RolesMenuSlice.reducer;
